import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import * as directives from './directive'

// Register global directives
Object.keys(directives).forEach(k => Vue.directive(k, directives[k]))

// Vue.use(ElementUI);
Vue.config.productionTip = false

// 开发环境下面使用vConsole进行调试
if (process.env.NODE_ENV === 'development') {
  const VConsole = require('vconsole')
  new VConsole()
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
